import React, { useContext } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import { useStateContext as useListingState } from "../context/ListingContext";
import { ThemeContext } from "styled-components";
import { Infosheet } from "../components";

const InfosheetPage = () => {
  const { listing } = useListingState();
  const theme = useContext(ThemeContext);
  return (
    <PDFViewer
      style={{ position: "absolute", border: 0, height: "100%", width: "100%" }}
    >
      <Infosheet listing={listing} theme={theme} />
    </PDFViewer>
  );
};

export default InfosheetPage;
